export default {
  nav: {
    services: 'Services',
    portfolio: 'Portfolio',
    process: 'Process',
    about: 'About us',
    hosting: 'Hosting',
    contact: 'Contact',
    cta: 'Start a conversation',
  },
  hero: {
    badge: 'Available for new projects',
    line1: 'Your idea.',
    line2: 'Our code.',
    line3: 'Live in weeks.',
    subtitle: 'You have an idea, we make sure it actually works. Design, frontend, backend and mobile. From first conversation to live product, without the fuss.',
    cta_primary: 'Tell us your idea',
    cta_secondary: 'View our work',
    scroll: 'Scroll',
    code_comment: '// Hello. We are Pixelated.',
    code_output: 'your product',
  },
  services: {
    label: '// What we build for you',
    title: 'Services',
    subtitle: 'No agency layers or meeting rounds. You talk directly to the people who design and build. Short lines, high speed.',
    web_title: 'MVP Development',
    web_desc: 'You want to know if your idea works before going all in. We build a sharp, functional product you can test, pitch and grow. Fast to launch, ready to scale.',
    web_deliverable: 'Working product, ready to test',
    app_title: 'Design & Development',
    app_desc: 'A designer who can\'t code costs you double. We do both: from wireframe to working code. Every detail is right, visually and technically.',
    app_deliverable: 'Design and code from one team',
    solutions_title: 'Software Extension',
    solutions_desc: 'Your system works but can\'t keep up anymore. We dive into the existing codebase, understand what\'s there and build it further without tearing everything down.',
    solutions_deliverable: 'Extension without restart or drama',
  },
  portfolio: {
    label: '// What we\'ve built',
    title: 'Featured projects',
    subtitle: 'Real projects, real clients. This is what we\'ve made for people like you.',
    view_project: 'View project',
    view_all: 'View all projects',
  },
  about: {
    label: '// Who we are',
    title: 'About us',
    bio1: 'Pixelated is a compact development studio from the Netherlands. We build complete digital products for entrepreneurs and companies who want to make something real. No agency overhead, no account managers. You talk directly to the makers.',
    bio2: 'We believe good software starts with truly understanding what someone needs. That\'s why we ask the hard questions before writing a single line of code. The result? A product that actually works for you and your users.',
    highlight1: 'Direct contact, no middlemen',
    highlight2: 'Design and development from one team',
    highlight3: 'We\'ll tell you when you need less',
    stat1_num: '20+',
    stat1_label: 'projects delivered',
    stat2_num: '5+',
    stat2_label: 'years experience',
    stat3_num: '1',
    stat3_label: 'dedicated point of contact',
    stack_title: 'Tech Stack',
  },
  hosting: {
    label: '// Hosting & maintenance',
    title: 'Hosting? Covered.',
    text: 'Building a product is step one. Keeping it reliably online is step two. For hosting and maintenance we work with our partner Quixor: fast servers, 24/7 monitoring and proactive maintenance. We build, they host — you never have to worry about it.',
    cta: 'Discover Quixor',
    note: 'Official hosting partner of Pixelated',
  },
  contact: {
    label: '// Let\'s talk',
    title: 'Say hello',
    intro: 'Send us a message. No obligations, no standard quote. Just an honest conversation about what you want to build and whether we\'re the right team to do it.',
    email_label: 'Email',
    response_label: 'Response time',
    response_value: 'Within 24 hours',
    location_label: 'Location',
    location_value: 'Netherlands, remote available',
    form_name: 'Name',
    form_name_placeholder: 'Your name',
    form_email: 'Email',
    form_type: 'Project type',
    form_type_placeholder: 'Choose a type',
    form_type_website: 'Website / web application',
    form_type_app: 'Mobile app',
    form_type_solution: 'Extend existing software',
    form_type_mvp: 'Build an MVP from scratch',
    form_type_other: 'Something else',
    form_budget: 'Budget',
    form_budget_placeholder: 'Choose a budget',
    form_message: 'Message',
    form_message_placeholder: 'Tell us what you want to build. The more context, the better we can help.',
    form_submit: 'Send message',
    success: 'Thanks! Your message has been sent. We\'ll be in touch soon.',
    error: 'Something went wrong. Try again or email us directly at info@pixelated-it.com',
    sending: 'Sending...',
  },
  werkwijze: {
    back: 'Back to home',
    title: 'How we work',
    subtitle: 'Short, direct and without hassle. This is what working with us looks like.',
    step1_title: 'We talk',
    step1_desc: 'We discuss your idea, context and goal. No intake form. Just an open conversation about what you want to build, why and what it takes.',
    step1_deliverable: 'Clarity on approach and feasibility',
    step2_title: 'We make a proposal',
    step2_desc: 'You get a concrete proposal: approach, planning and price. No fine print, no surprises. If something isn\'t feasible, we\'ll say so.',
    step2_deliverable: 'Clear proposal with timeline and price',
    step3_title: 'We build together',
    step3_desc: 'We work iteratively. Every week you see progress. You can give feedback, ask questions and steer. This is your product, we build it with you.',
    step3_deliverable: 'Weekly updates + working software',
    step4_title: 'Live',
    step4_desc: 'Deployment, handover and explanation. You know exactly how everything works and how to manage it yourself. After launch, we stay available for questions.',
    step4_deliverable: 'Live product + full documentation',
    cta_title: 'Does this sound good?',
    cta_desc: 'Step 1 is free and without obligation. Tell us what you want to build.',
    cta_button: 'Send us a message',
  },
  footer: {
    built_with: 'Built with Vue & Spring Boot',
  },
  portfolio_page: {
    back: 'Back to home',
    subtitle: 'All projects, from rough sketch to working product.',
    filter_all: 'All',
    filter_web: 'Web',
    filter_mobile: 'Mobile',
    filter_backend: 'Backend',
    view_project: 'View project',
    category_web: 'Web',
    category_mobile: 'Mobile',
    category_backend: 'Backend',
    empty: 'No projects in this category.',
  },
}
